/* eslint-disable @typescript-eslint/no-use-before-define */
import React, {
	ReactElement,
	useState,
	useContext,
	useEffect,
	ChangeEvent,
} from "react"
import { useFormik } from "formik"
import { Button, Box, Grid, TextField } from "@material-ui/core"
import { useHistory } from "react-router-dom"
import { BaseCFCStruct } from "../../../data/_config/shape"
import { initialValues } from "."
import { PanelsTitle } from "../../CFC"
import Spacer from "../../Spacer/Spacer"
import { routeVarReplacement, PrivateRoutes } from "../../../util/routes/routes"
import useCurrentClient from "../../../state/client/useCurrentClient"
import useStyles from "./__config/styles"
import formatNumber from "../../../util/formatNumber"
import onCreate from "./onCreate"
import { useParams } from "react-router-dom"
import CFCUseCase from "../../../data/CFC/CFCLogic"

/**
 * Create canvas form.
 *
 * @export
 * @returns {ReactElement}
 */

export default function Step5Form({
	osveziMaster,
	values,
}: {
	osveziMaster: (values: any) => void
	values: any
}): ReactElement {
	const styles = useStyles()
	const { id: canvasId } = useParams<any>()

	const [useCustomTitle, setUseCustomTitle] = useState(false)
	const history = useHistory()
	const [currentClient] = useCurrentClient()

	const {
		setFieldValue,
		handleChange,
		// values,
		handleSubmit,
	} = useFormik<BaseCFCStruct>({
		initialValues,
		onSubmit: async (formValues: BaseCFCStruct) => {},
	})

	const {
		step1Items,
		step1CalculatedData,
		step2Items,
		step3Items,
		ukupniTroskovi,
		canvasStartDate,
		step4Items,
		step5Items,
	} = values

	const prizemljeCount = +step1Items[5].Vrednost
	const tipskiSpratCount = +step1Items[6].Vrednost
	const potkrovljeCount = +step1Items[7].Vrednost
	const povucenSpratCount = +step1Items[8].Vrednost

	const prizemljeNeto = +step1CalculatedData[4][2]
	const tipskiSpratNeto = +step1CalculatedData[5][2]
	const potkrovljeNeto = +step1CalculatedData[6][2]
	const povucenSpratNeto = +step1CalculatedData[7][2]

	const TrosakTotal = ukupniTroskovi
	const podzemnoSpratnost = step2Items ? step2Items.spratType : undefined
	const nadzemnoSpratnost =
		step1CalculatedData && step1CalculatedData[10]
			? step1CalculatedData[10][1]
			: undefined //6

	const onPrev = async () => {
		if (currentClient?.id) {
			values.step5Items = { nadzemno, podzemno, prilivi }
			values.ukupniPrihodi =
				calculateTotalAmount(podzemno, "Iznos") +
				calculateTotalAmount(nadzemno, "Iznos")

			let id = canvasId

			id && id != ":id"
				? await CFCUseCase.update(canvasId, values)
				: (id = await onCreate(values, currentClient.id))
			// const query = createURLParams(formValues, useCustomTitle)
			const query = ""
			// eslint-disable-next-line
			history.push(
				`${routeVarReplacement(PrivateRoutes.PlanningStep4, [
					[":id", `${canvasId || id}`],
				])}?${query}`
			)
		}
	}

	const onNext = async () => {
		if (currentClient?.id) {
			values.step5Items = { nadzemno, podzemno, prilivi }
			values.ukupniPrihodi =
				calculateTotalAmount(podzemno, "Iznos") +
				calculateTotalAmount(nadzemno, "Iznos")

			let id = canvasId

			id && id != ":id"
				? await CFCUseCase.update(canvasId, values)
				: (id = await onCreate(values, currentClient.id))
			// const query = createURLParams(formValues, useCustomTitle)
			const query = ""
			// eslint-disable-next-line
			history.push(
				`${routeVarReplacement(PrivateRoutes.PlanningStep6, [
					[":id", `${canvasId || id}`],
				])}?${query}`
			)
		}
	}

	const calculateTotalAmount = (groupData, kolona) => {
		let totalAmount = 0

		for (const item of groupData) {
			totalAmount += +item[kolona] || 0
		}

		return totalAmount
	}

	const generisiSpratnostNiz = () => {
		const spratnostData = []

		for (let i = 1; i <= prizemljeCount; i++) {
			if (i > 0) {
				spratnostData.push({
					Naziv: "Prizemlje",
					kolicina: prizemljeNeto,
					cena: 2500,
					Iznos: null,
					Interval: 3,
				})
			}
		}

		for (let i = 1; i <= tipskiSpratCount; i++) {
			if (i > 0) {
				spratnostData.push({
					Naziv: i,
					kolicina: tipskiSpratNeto,
					cena: 3000,
					Iznos: null,
					Interval: 1,
				})
			}
		}

		for (let i = 1; i <= potkrovljeCount; i++) {
			if (i > 0) {
				spratnostData.push({
					Naziv: "Potkrovlje",
					kolicina: potkrovljeNeto,
					cena: 4000,
					Iznos: null,
					Interval: 2,
				})
			}
		}

		for (let i = 1; i <= povucenSpratCount; i++) {
			if (i > 0) {
				spratnostData.push({
					Naziv: "Povučeni sprat",
					kolicina: povucenSpratNeto,
					cena: 4500,
					Iznos: null,
					Interval: 2,
				})
			}
		}

		return spratnostData
	}

	useEffect(() => {
		if (!useCustomTitle) {
			setFieldValue("canvasTitle", "")
		}
	}, [useCustomTitle, setFieldValue])

	const [nadzemno, setNadzemno] = useState(
		step5Items && nadzemnoSpratnost == step5Items.nadzemno.length
			? step5Items.nadzemno
			: generisiSpratnostNiz()
	)

	const generisiPodzemnoNiz = () => {
		const spratnostData = []

		for (let i = 1; i <= podzemnoSpratnost; i++) {
			if (i > 0) {
				spratnostData.push({
					Naziv: "-" + i,
					kolicina: step2Items ? step2Items.brojParkinga : 0,
					cena: 20000,
					Iznos: null,
					Interval: 4 + i,
				})
			}
		}

		return spratnostData
	}

	const [podzemno, setPodzemno] = useState(
		step5Items &&
			step2Items &&
			step5Items.podzemno[0] &&
			step2Items.brojParkinga == step5Items.podzemno[0].kolicina &&
			podzemnoSpratnost == step5Items.podzemno.length
			? step5Items.podzemno
			: generisiPodzemnoNiz()
	)

	const [prilivi, setPrilivi] = useState(
		step5Items
			? step5Items.prilivi
			: [
					{
						Naziv: "Sopstvena sredstva",
						Trosak: 3,
						Ucesce: 30,
						Iznos: null,
					},
					{ Naziv: "Rana prodaja", Trosak: 8, Ucesce: 10, Iznos: null },
					{ Naziv: "Kredit – kamata", Trosak: 6, Ucesce: 60, Iznos: null },
			  ]
	)

	useEffect(() => {
		values.ukupniPrihodi =
			calculateTotalAmount(podzemno, "Iznos") +
			calculateTotalAmount(nadzemno, "Iznos")

		// values.priliviTotal =
		// 	calculateTotalAmount(prilivi, "Iznos")

		osveziMaster(values)
	}, [values])

	const InputLabelInvisibility = () => {
		return (
			<TextField
				variant="outlined"
				disabled={true}
				style={{ width: "100%", visibility: "hidden" }}
			/>
		)
	}

	const InputLabelCustom = (props: any) => {
		return (
			<TextField
				variant="outlined"
				value={props.value}
				disabled={true}
				style={{ width: "100%" }}
				inputProps={{ style: props.style }}
			/>
		)
	}

	const NadzemnoTable = ({ data, setNadzemno }) => {
		const [rows, setRows] = useState(data)

		const calculateTotal = (index, cena) => {
			const updatedRows = rows.map((row, i) => {
				if (i === index) {
					const Iznos = isNaN(cena) ? 0 : row.kolicina * cena
					return { ...row, cena, Iznos }
				}
				return row
			})
			setRows(updatedRows)
			setNadzemno(updatedRows)

			values.ukupniPrihodi =
				calculateTotalAmount(podzemno, "Iznos") +
				calculateTotalAmount(updatedRows, "Iznos")

			osveziMaster(values)
		}

		const totalKolicina = rows.reduce((total, row) => total + row.kolicina, 0)
		const totalIznos = rows.reduce((total, row) => total + (row.Iznos || 0), 0)

		return (
			<div>
				<table>
					<thead>
						<tr>
							<th style={{ textAlign: "left" }}>Sprat</th>
							<th style={{ textAlign: "left" }}>Neto</th>
							<th style={{ textAlign: "left" }}>Cena</th>
							<th style={{ textAlign: "left" }}>Ukupno</th>
						</tr>
					</thead>
					<tbody>
						{rows.map((row, index) => {
							row.Iznos = isNaN(row.cena) ? 0 : row.kolicina * row.cena
							return (
								<tr key={index}>
									<td>{row.Naziv}</td>
									<td>{row.kolicina}</td>
									<td>
										<input
											type="number"
											step="10"
											defaultValue={row.cena || ""}
											onBlur={(e) => {
												// Ovdje pozivamo calculateTotal kada element izgubi fokus (blur)
												calculateTotal(index, parseFloat(e.target.value))
											}}
										/>
									</td>
									<td>
										{row.Iznos
											? row.Iznos.toLocaleString("sr-RS", {
													minimumFractionDigits: 0,
													maximumFractionDigits: 0,
											  })
											: "0"}
									</td>
								</tr>
							)
						})}
						<tr>
							<td>
								<strong>Ukupno</strong>
							</td>
							<td>
								<strong>
									{totalKolicina.toLocaleString("sr-RS", {
										minimumFractionDigits: 0,
										maximumFractionDigits: 0,
									})}
								</strong>
							</td>
							<td></td>
							<td>
								<strong>
									{totalIznos.toLocaleString("sr-RS", {
										minimumFractionDigits: 0,
										maximumFractionDigits: 0,
									})}
								</strong>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		)
	}

	const PodzemnoTable = ({ data, setPodzemno }) => {
		const [rows, setRows] = useState(data)

		const calculateTotal = (index, cena) => {
			const updatedRows = rows.map((row, i) => {
				if (i === index) {
					const Iznos = isNaN(cena) ? 0 : row.kolicina * cena
					return { ...row, cena, Iznos }
				}
				return row
			})
			setRows(updatedRows)
			setPodzemno(updatedRows)

			values.ukupniPrihodi =
				calculateTotalAmount(updatedRows, "Iznos") +
				calculateTotalAmount(nadzemno, "Iznos")

			osveziMaster(values)
		}

		const totalKolicina = rows.reduce((total, row) => total + row.kolicina, 0)
		const totalIznos = rows.reduce((total, row) => total + (row.Iznos || 0), 0)

		return (
			<div>
				<table>
					<thead>
						<tr>
							<th style={{ textAlign: "left" }}>Sprat</th>
							<th style={{ textAlign: "left" }}>Komada</th>
							<th style={{ textAlign: "left" }}>Cena</th>
							<th style={{ textAlign: "left" }}>Ukupno</th>
						</tr>
					</thead>
					<tbody>
						{rows.map((row, index) => {
							row.Iznos = isNaN(row.cena) ? 0 : row.kolicina * row.cena
							return (
								<tr key={index}>
									<td>{row.Naziv}</td>
									<td>{row.kolicina}</td>
									<td>
										<input
											style={{
												width: "85%",
											}}
											type="number"
											step="100"
											defaultValue={row.cena || ""}
											onBlur={(e) =>
												calculateTotal(index, parseFloat(e.target.value))
											}
										/>
									</td>
									<td>
										{row.Iznos
											? row.Iznos.toLocaleString("sr-RS", {
													minimumFractionDigits: 0,
													maximumFractionDigits: 0,
											  })
											: "0"}
									</td>
								</tr>
							)
						})}
						<tr>
							<td>
								<strong>Ukupno</strong>
							</td>
							<td>
								<strong>
									{totalKolicina.toLocaleString("sr-RS", {
										minimumFractionDigits: 0,
										maximumFractionDigits: 0,
									})}
								</strong>
							</td>
							<td></td>
							<td>
								<strong>
									{totalIznos.toLocaleString("sr-RS", {
										minimumFractionDigits: 0,
										maximumFractionDigits: 0,
									})}
								</strong>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		)
	}

	const PriliviTable = ({ data, TrosakTotal, setPrilivi }) => {
		const [rows, setRows] = useState(data)

		useEffect(() => {
			// Inicijalizujemo Iznos za svaki red na osnovu postojećih podataka o trosku i učešću
			const updatedRows = rows.map((row) => {
				const Iznos = TrosakTotal * (row.Ucesce / 100) * (row.Trosak / 100)
				return { ...row, Iznos }
			})
			setRows(updatedRows)
		}, [TrosakTotal])

		const calculateIznos = (index, Trosak, Ucesce) => {
			const Iznos = TrosakTotal * (Ucesce / 100) * (Trosak / 100)
			const updatedRows = rows.map((row, i) => {
				if (i === index) {
					return { ...row, Trosak, Ucesce, Iznos }
				}
				return row
			})
			setRows(updatedRows)
			setPrilivi(updatedRows)

			// values.priliviTotal =
			// 	calculateTotalAmount(updatedRows, "Iznos")

			// osveziMaster(values)
		}

		// Izračunavanje ukupnog Iznosa
		const totalIznos = rows.reduce((total, row) => total + (row.Iznos || 0), 0)

		return (
			<div>
				<table>
					<thead>
						<tr>
							<th style={{ textAlign: "left" }}>Naziv</th>
							<th style={{ textAlign: "left" }}>Trošak (%)</th>
							<th style={{ textAlign: "left" }}>Učešće (%)</th>
							<th style={{ textAlign: "left" }}>Troškovi finansiranja</th>
						</tr>
					</thead>
					<tbody>
						{rows.map((row, index) => (
							<tr key={index}>
								<td
									style={{
										width: "200px",
									}}
								>
									{row.Naziv}
								</td>
								<td>
									<input
										type="number"
										min="0"
										max="100"
										step="0.5"
										defaultValue={row.Trosak}
										onBlur={(e) => {
											const Trosak = parseFloat(e.target.value)
											calculateIznos(index, Trosak, row.Ucesce)
										}}
									/>
								</td>
								<td>
									<input
										type="number"
										min="0"
										max="100"
										step="1"
										defaultValue={row.Ucesce}
										onBlur={(e) => {
											const Ucesce = parseFloat(e.target.value)
											calculateIznos(index, row.Trosak, Ucesce)
										}}
									/>
								</td>
								<td>
									{row.Iznos
										? Math.ceil(row.Iznos).toLocaleString("sr-RS", {
												minimumFractionDigits: 0,
												maximumFractionDigits: 0,
										  })
										: "0"}
								</td>
							</tr>
						))}
						<tr>
							<td>
								<strong>Ukupno</strong>
							</td>
							<td></td>
							<td></td>
							<td>
								<strong>
									{Math.ceil(totalIznos).toLocaleString("sr-RS", {
										minimumFractionDigits: 0,
										maximumFractionDigits: 0,
									})}
								</strong>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		)
	}

	return (
		<>
			<Box className={styles.box}>
				<Button
					color="primary"
					variant="outlined"
					type="submit"
					onClick={onPrev}
				>
					Dinamika
				</Button>
				<Button
					color="primary"
					variant="outlined"
					type="submit"
					onClick={onNext}
				>
					Rizici
				</Button>
			</Box>
			<form onSubmit={handleSubmit} data-reactour="create-a-canvas">
				<PanelsTitle customTitle={"Prihodi i prilivi"} useCustomTitle={true} />
				<Spacer />
				<Spacer />
				<Box className={styles.box}>
					<Grid
						container
						// spacing={1}
						// alignItems="center"
						justify="center"
						// alignContent="center"
					>
						<InputLabelCustom
							value="Prihodi - prodajne cene"
							style={{ fontWeight: "bold", color: "black" }}
						/>
						<InputLabelInvisibility />
						<Grid xs={4}>
							<InputLabelCustom value="Spratnost nadzemno" />

							<NadzemnoTable data={nadzemno} setNadzemno={setNadzemno} />
						</Grid>
						<Grid xs={1}></Grid>
						<Grid xs={4}>
							<InputLabelCustom value="Spratnost podzemno" />
							<PodzemnoTable data={podzemno} setPodzemno={setPodzemno} />
						</Grid>

						<InputLabelInvisibility />
						<InputLabelCustom
							value="Prilivi - parametri finansiranja projekta"
							style={{ fontWeight: "bold", color: "black" }}
						/>
						<InputLabelInvisibility />
						<PriliviTable
							data={prilivi}
							TrosakTotal={TrosakTotal}
							setPrilivi={setPrilivi}
						/>
					</Grid>
				</Box>
			</form>
		</>
	)
}
